/* ============================================================
   BC RUN METHOD — Shopify Theme JS
   Developer note: Stripe integration point is in handleSubmit().
   Replace the TODO comment with your Stripe Checkout redirect.
   ============================================================ */

/* ---------- Video play handler ---------- */
function playBrandVideo() {
  var video  = document.getElementById('brandVideo');
  var poster = document.getElementById('videoPoster');
  if (!video) return;
  poster.classList.add('hidden');
  video.play().catch(function(err) {
    console.log('Playback failed:', err);
    poster.classList.remove('hidden');
  });
}

/* ---------- Intake form submit ---------- */
function handleSubmit(e) {
  e.preventDefault();

  var toast = document.getElementById('toast');
  if (toast) {
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3500);
  }

  /*
   * TODO: Replace this block with your Stripe Checkout redirect.
   * Example using Stripe.js:
   *
   *   var stripe = Stripe('YOUR_PUBLISHABLE_KEY');
   *   stripe.redirectToCheckout({ lineItems: [...], mode: 'payment', ... });
   *
   * Or redirect to a Shopify cart / external checkout URL:
   *   window.location.href = '/checkout?...';
   */

  document.getElementById('intakeForm').reset();
}

/* ---------- FAQ accordion ---------- */
document.addEventListener('DOMContentLoaded', function() {

  /* Delegate click for FAQ items */
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.addEventListener('click', function() {
      this.classList.toggle('open');
    });
  });

  /* ---------- Scroll-reveal for sections ---------- */
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity  = '1';
        entry.target.style.transform = 'translateY(0)';
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('section:not(.hero)').forEach(function(s) {
    s.style.opacity   = '0';
    s.style.transform = 'translateY(24px)';
    s.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    revealObserver.observe(s);
  });

  /* ---------- Shopify Section Events (theme editor live preview) ---------- */
  /* Re-run reveal when a section is selected in the theme editor */
  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('section:not(.hero)').forEach(function(s) {
      s.style.opacity   = '1';
      s.style.transform = 'translateY(0)';
    });
  });

});
